import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import {
  AppState,
  FramesActionTypes,
  selectFramesList,
  selectFramesLoaded,
  selectPatientId,
} from '@app/core/ngrx';
import { ExportBrandPdfService, SearchService } from '@app/core/services';
import { Observable } from 'rxjs';
import { State } from '@ngrx/store';
import { Frame } from '@app/core/models';

@Component({
  selector: 'ecp-order-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent implements OnInit {
  frame: any;
  frame$: Observable<any>;
  isExportingBrand: boolean;
  framesLoaded$: Observable<boolean>;
  upc: string;
  patientId: string;
  patientId$: Observable<string>;
  patientIdValue;
  url: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private store: Store<AppState>,
    private searchService: SearchService,
    private state: State<AppState>,
    private exportBrandPdfService: ExportBrandPdfService,
  ) {
    this.frame$ = this.store.pipe(select(selectFramesList));
    this.framesLoaded$ = this.store.pipe(select(selectFramesLoaded));
    this.patientId$ = this.store.pipe(select(selectPatientId));
    this.patientId$.subscribe(patientId => {
      this.patientIdValue = patientId;
    });
    this.frame$.subscribe(frames => {
      if (frames && frames.loaded) {
        let filtered = frames.list.frames.filter(a => a.upc === this.upc);
        this.frame = filtered && filtered.length ? filtered[0] : null;
      }
    });

    this.framesLoaded$.subscribe(loaded => {
      this.isExportingBrand = !loaded;
    });
    let id = this.patientIdValue;
    this.url = id ? '/' + id : '/catalog';
    this.patientId = id;
  }

  /**
   * ngOnInit
   * @description
   */
  ngOnInit(): void {}

  exportBrand() {
    this.isExportingBrand = true;
    this.searchService
      .searchFrames({
        brands: [this.frame.brandName],
        terms: [],
        sizes: [],
        limit: 1000,
        skip: 0,
      })
      .subscribe(frames => {
        let programKeyState = this.state.getValue().user.profile.program
          .programKey;
        let framesList = frames.frames;
        this.exportBrandPdfService
          .exportBrandProcess(framesList, programKeyState)
          .subscribe(resp => {
            this.isExportingBrand = false;
          });
      });
  }
}
